import { posToDOMRect } from "@tiptap/core";
import { DateCheckedSmall, OrderSmall, WixBookingSmall } from "@wix/wix-ui-icons-common";
import { AppEmbedData_AppType } from "./../ricos-schema/legacy/wix/rich_content/v1";
import { quickActionsModalSections, RicosPluginToolbarNames } from "./../ricos-types";
import { changeSelectionToEndOfTextBlock } from "./../wix-rich-content-common";
import { appEmbedConverter } from "./app-embed-converter";
import { verticalEmbedModals } from "./constants";
import { getAddButtons } from "./getAddButtons";
import { getToolbarButtons } from "./getToolbarButtons";
import { InsertModal } from "./modals/InsertModal";
import { tiptapExtensions } from "./tiptap/tiptap";
import { VERTICAL_EMBED_TYPE } from "./types";
const pluginVerticalEmbed = (config) => {
  const pluginConfig = { ...config };
  return {
    config: pluginConfig,
    type: VERTICAL_EMBED_TYPE,
    tiptapExtensions,
    pmMarkConverters: [],
    pmNodeConverters: [appEmbedConverter],
    toolbar: {
      names: [RicosPluginToolbarNames.APP_EMBED],
      getButtons: (config2, services) => getToolbarButtons(config2, services)
    },
    getAddButtons: (config2, services) => getAddButtons(config2, services),
    __exports: {
      InsertModal
    },
    getQuickActions: ({ config: config2, pluginServices }) => {
      const toggleInsertModal = ({
        id,
        type,
        modalService,
        editor
      }) => modalService?.togglePluginPanel({
        id,
        Component: InsertModal,
        componentProps: {
          verticalsApi: config2?.verticalsApi,
          componentData: { type },
          modalId: id
        },
        positioning: {
          referenceElement: {
            getBoundingClientRect: () => posToDOMRect(
              editor.view,
              editor.view.state.selection.from,
              editor.view.state.selection.to
            )
          },
          placement: "bottom-end"
        },
        isMobile: pluginServices?.context.isMobile
      });
      return [
        {
          id: "product",
          title: "QuickActionsPlugin_ActionTitle_Product",
          icon: OrderSmall,
          section: quickActionsModalSections.EmbedWix,
          tags: [
            "item",
            "merchandise",
            "product card",
            "shop item",
            "e-commerce",
            "online store",
            "store item"
          ],
          command: ({ modalService, editor }) => {
            changeSelectionToEndOfTextBlock(editor);
            toggleInsertModal({
              id: verticalEmbedModals.insertProduct,
              type: AppEmbedData_AppType.PRODUCT,
              modalService,
              editor
            });
          }
        },
        {
          id: "event",
          title: "QuickActionsPlugin_ActionTitle_Event",
          icon: DateCheckedSmall,
          section: quickActionsModalSections.EmbedWix,
          tags: ["calendar", "meeting", "appointment", "schedule", "date", "time"],
          command: ({ modalService, editor }) => {
            changeSelectionToEndOfTextBlock(editor);
            toggleInsertModal({
              id: verticalEmbedModals.insertEvent,
              type: AppEmbedData_AppType.EVENT,
              modalService,
              editor
            });
          }
        },
        {
          id: "service",
          title: "QuickActionsPlugin_ActionTitle_Service",
          icon: WixBookingSmall,
          section: quickActionsModalSections.EmbedWix,
          tags: ["reservation", "appointment", "schedule", "time", "calendar", "ticket", "booking"],
          command: ({ modalService, editor }) => {
            changeSelectionToEndOfTextBlock(editor);
            toggleInsertModal({
              id: verticalEmbedModals.insertBooking,
              type: AppEmbedData_AppType.BOOKING,
              modalService,
              editor
            });
          }
        }
      ];
    }
  };
};
export {
  pluginVerticalEmbed
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject";
injectCss();
